module.exports = __webpack_public_path__ + "img/vrbox.35f9dfca.png";